import { render, staticRenderFns } from "./CourseFilter.vue?vue&type=template&id=915009bc&scoped=true"
import script from "./CourseFilter.vue?vue&type=script&lang=js"
export * from "./CourseFilter.vue?vue&type=script&lang=js"
import style0 from "./CourseFilter.vue?vue&type=style&index=0&id=915009bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915009bc",
  null
  
)

export default component.exports